import { Ellipsis, Grid, Image, Image as ImageMobile, ImageViewer, Input, Modal, Switch, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import img from 'app/img';
import axios from 'axios';
import { getCypher } from 'components/dot/shareCypher';
import dayjs from 'dayjs';
import { isDraft } from 'immer';
import { useEffect, useState } from 'react';
import {
    AiFillCheckCircle,
    AiFillCloseCircle,
    AiFillEuroCircle,
    AiFillInfoCircle,
    AiFillPlusCircle,
    AiFillQuestionCircle,
    AiOutlineArrowUp,
    AiOutlineMenu,
    AiOutlineShareAlt,
} from 'react-icons/ai';
import SickzilApi, { OpsClassifyParams, OpsImageDT, OpsProcessBO, PredictionDTO } from 'services/apis/_ops/Sickzil-api';
import { bizBaseUrlLocal, useNAT } from 'services/request';
import { useImmer } from 'use-immer';
import { copy2Clipboard } from 'utils/clipboardUtil';
import downloadUtil, { downloadImageStrong } from 'utils/downloadUtil';
import { scrollTop } from 'utils/screenUtil';

const Ops = () => {
  // 图片详情，非空则展示 ImageViewer
  const [viewerImage, setViewerImage] = useState<OpsImageDT>(null);
  // true双栏模式 false三栏模式
  const [bigMode, toggleBigMode] = useState(false);
  // 0未选 1废弃 2保留
  const [actionType, setActionType] = useState(0);
  // 选择的图片列表
  const [selectList, updateSelectList] = useImmer<string[]>([]);
  // 操作进度
  const [opsProcess, updateOpsProcess] = useImmer<OpsProcessBO>({ waitCount: 0, trashCount: 0, keepCount: 0 });
  // 展示的图片列表
  const [imageList, updateImageList] = useImmer<OpsImageDT[]>([]);

  const pageImageAction = (actionType: number, strict?: boolean, pageSize?: number) => {
    updateSelectList((draft) => {
      draft = [];
      return draft;
    });

    SickzilApi.pageImageAction({
      pageCurrent: 0,
      pageSize: pageSize || 600,
      actionType: actionType,
      strict: strict,
    }).then((resp) => {
      if (resp.successful) {
        const result = resp.result;
        console.log('result', result, resp);
        result.forEach((item) => {
          item.imageUrlOnline = !useNAT
            ? item.imageUrlOnline
            : item.imageUrlOnline?.replace('http://192.168.31.60:8080', bizBaseUrlLocal);
        });
        updateImageList((draft) => {
          draft = result;
          return draft;
        });
      }
    });
  };

  const fetchProcess = () => {
    SickzilApi.opsProcess(false).then((resp) => {
      if (resp.successful) {
        updateOpsProcess((draft) => {
          draft = resp.result;
          return draft;
        });
      }
    });
  };

  useEffect(() => {
    pageImageAction(0, true);
    fetchProcess();
  }, []);

  // 页面内容
  return (
    <div className=" relative overflow-hidden h-full text-xs">
      {/* 控制条 */}
      <div className=" h-32 w-full fixed top-0 z-10 bg-gradient-to-br from-pink-300 to-sky-300 py-2">
        {/* 查看详情 */}
        {/* <div className=" shadow-md rounded-md text-white bg-gradient-to-br from-purple-300/100 to-pink-500/100 p-3 m-2 text-center">
          查看详情
        </div> */}
        {/* 处理进度 */}
        <div className=" flex justify-between items-center gap-2 mx-2 mb-2 text-center">
          <div
            className={[' grow bg-slate-500 shadow-md rounded-md text-white p-2'].join(' ')}
            onClick={() => {
              pageImageAction(1);
            }}
          >
            已废弃
            <div>{opsProcess.trashCount || 0}</div>
          </div>
          <div
            className={[' relative grow bg-slate-500 shadow-md rounded-md text-white p-2'].join(' ')}
            onClick={() => {
              pageImageAction(0);
            }}
          >
            待处理/总数
            <div>
              {(opsProcess.waitCount || 0) +
                ' / ' +
                (opsProcess.waitCount + opsProcess.trashCount + opsProcess.keepCount || 0)}
            </div>
            <div
              className=" w-6 h-6 text-xs flex justify-center items-center rounded-3xl shadow-md bg-red-500 text-white absolute top-0 right-0 m-1"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const submit = window.confirm('确认重置？');
                if (!submit) {
                  Toast.show('取消操作');
                  return;
                }
                SickzilApi.opsReset();
                fetchProcess();
              }}
            >
              R
            </div>
            <div
              className=" w-6 h-6 text-xs flex justify-center items-center rounded-3xl shadow-md bg-red-500 text-white absolute top-0 left-0 m-1"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await pageImageAction(0, false);
              }}
            >
              N
            </div>
          </div>

          <div
            className={[' grow bg-slate-500 shadow-md rounded-md text-white p-2'].join(' ')}
            onClick={() => {
              pageImageAction(2, true, 30);
            }}
          >
            已保留
            <div>{opsProcess.keepCount || 0}</div>
          </div>
        </div>
        {/* 操作模式 */}
        <div className=" gap-2 mx-2 text-center flex justify-between items-center">
          <div
            className={[
              actionType == 1 ? ' brightness-100' : ' brightness-75',
              ' bg-red-500 shadow-md rounded-md text-white py-3 grow',
            ].join(' ')}
            onClick={() => {
              setActionType(actionType == 1 ? 0 : 1);
            }}
          >
            废弃模式（{actionType == 1 ? 'now' : 'non'}）
          </div>
          <div
            className={[
              bigMode ? ' brightness-100' : ' brightness-75',
              ' bg-slate-500 shadow-md rounded-md text-white py-1.5 px-2',
            ].join(' ')}
          >
            <Switch
              className=" scale-90"
              checked={bigMode}
              checkedText={<span>双栏模式</span>}
              uncheckedText={<span>三栏模式</span>}
              onChange={(checked) => {
                toggleBigMode(checked);
              }}
            />
          </div>
          <div
            className={[
              actionType == 2 ? ' brightness-100' : ' brightness-50',
              ' bg-sky-500 shadow-md rounded-md text-white py-3 grow',
            ].join(' ')}
            onClick={() => {
              setActionType(actionType == 2 ? 0 : 2);
            }}
          >
            保留模式（{actionType == 2 ? 'now' : 'non'}）
          </div>
        </div>
        {/* 搜索 */}
        <div className=" m-2">
          <input
            placeholder="标题/原帖子id"
            className=" text-center p-2 h-8 w-full text-white bg-slate-500/90 rounded-md shadow-md"
            onKeyDown={async (e) => {
              if (e.key == 'Enter') {
                //@ts-ignore
                const key: string = e.target.value;
                Toast.show('搜索标题：' + key);

                const resp = await SickzilApi.pageImage({
                  pageCurrent: 0,
                  pageSize: 999,
                  searchPostTitle: !key.match(/^\d+$/) ? key : null,
                  searchSourcePostId: key.match(/^\d+$/) ? key : null,
                  actionType: null,
                  isNsfw: null,
                });
                console.log(resp);
                if (resp.successful) {
                  updateImageList((draft) => {
                    draft = resp.result;
                    return draft;
                  });
                }
              }
            }}
          />
        </div>
      </div>
      {/* 人工审核 */}
      <div className={[' pt-32 h-full overflow-scroll'].join(' ')}>
        {/* 图片详情 */}
        <ImageViewer
          image={!useNAT ? viewerImage?.imageUrl : viewerImage?.imageUrlOnline}
          classNames={{ mask: 'myStyles.customStyles', body: 'myStyles.customStyles' }}
          maxZoom={2}
          visible={viewerImage != null}
          onClose={() => {
            setViewerImage(null);
          }}
          renderFooter={(imageUrl: string) => {
            return (
              <div>
                <div className="fixed top-0 w-full bg-slate-50 p-2 text-[10px]/3 text-nowrap overflow-hidden">
                  <div>帖子标题：{viewerImage.postTitle}</div>
                  <div>图片名称：{viewerImage.imageName}</div>
                  <div>资源口令：{viewerImage.cypherKey}</div>
                  <div>传播口令：{getCypher(viewerImage.cypherKey)}</div>
                  <div>发布次数：{viewerImage.publishTimes}</div>
                  <Grid columns={4}>
                    <span>预先废弃：{viewerImage.preTrash == 1 ? '是' : '否'}</span>
                    <span>色情废弃：{viewerImage.isNsfw == 1 ? '是' : '否'}</span>
                    <span>单色废弃：{viewerImage.preTrashSolid == 1 ? '是' : '否'}</span>
                    <span>
                      操作类型：{viewerImage.actionType == 0 ? '待定' : viewerImage.actionType == 1 ? '舍弃' : '保留'}
                    </span>
                  </Grid>
                </div>
                <div className=" flex justify-center items-center gap-5 m-5">
                  <div
                    className=" rounded-md shadow-md bg-slate-500/50 text-white p-2 m-2"
                    onClick={() => {
                      const cypher = viewerImage.cypherKey;
                      const imageSuffix = imageUrl.slice(imageUrl.lastIndexOf('.'));
                      const imageName =
                        dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') + '_' + cypher + '_' + imageUrl + imageSuffix;
                      downloadImageStrong({ imageUrl, imageName });
                    }}
                  >
                    下载图片
                  </div>
                  <div
                    className=" rounded-md shadow-md bg-slate-500/50 text-white p-2 m-2"
                    onClick={() => {
                      const cypher = getCypher(viewerImage.cypherKey);
                      copy2Clipboard(cypher);
                      Toast.show('已复制口令');
                    }}
                  >
                    复制口令
                  </div>
                  <div
                    className=" rounded-md shadow-md bg-slate-500/50 text-white p-2 m-2"
                    onClick={() => {
                      SickzilApi.opsPublish(viewerImage.imageName);
                      Toast.show('次数已+1');
                    }}
                  >
                    确认采用
                  </div>
                </div>
              </div>
            );
          }}
        />
        {/* 图片列表 */}
        <div
          className=" m-2"
          style={{
            columnCount: bigMode ? 2 : 3,
            columnGap: 8,
          }}
        >
          {imageList?.map((item, index) => (
            <div
              key={item.imageName + index + Math.random()}
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '100%',
                breakInside: 'avoid' /* 避免图片被分割到不同列 */,
              }}
              onClick={() => {
                if (actionType == 0) {
                  Toast.show('请选择模式');
                  return;
                } else {
                  updateSelectList((draft) => {
                    // 包含就移除,不包含就添加
                    if (draft.includes(item.imageName)) {
                      draft.splice(draft.indexOf(item.imageName), 1);
                    } else {
                      draft.push(item.imageName);
                    }
                    return draft;
                  });
                }
              }}
            >
              <div className=" relative">
                <img
                  crossOrigin="anonymous"
                  key={item.imageName}
                  src={!useNAT ? item.imageUrl : item.imageUrlOnline}
                  className=" w-full rounded-md shadow-xl object-cover border border-slate-500"
                  style={{ minHeight: window.innerWidth / 3 }}
                />
                <div className=" absolute top-0 right-0 w-full p-1 gap-2 flex justify-between items-center">
                  {/* 占位 */}
                  <AiFillCheckCircle
                    size={30}
                    className=" text-orange-500/80 invisible"
                  />
                  {/* 占位 */}
                  <AiFillCheckCircle
                    size={30}
                    className=" text-orange-500/80 invisible"
                  />
                  {/* 搜索原id */}
                  <AiFillInfoCircle
                    size={30}
                    className=" text-orange-500/80"
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      const key = item.imageName.split('-')[0];
                      Toast.show('搜索原id：' + key);

                      const resp = await SickzilApi.pageImage({
                        pageCurrent: 0,
                        pageSize: 999,
                        searchPostTitle: !key.match(/^\d+$/) ? key : null,
                        searchSourcePostId: key.match(/^\d+$/) ? key : null,
                        actionType: null,
                        isNsfw: null,
                      });
                      console.log(resp);
                      if (resp.successful) {
                        updateImageList((draft) => {
                          draft = resp.result;
                          return draft;
                        });
                      }
                    }}
                  />
                </div>
                <div className=" absolute bottom-0 w-full p-1 gap-2 flex justify-between items-center">
                  {/* 选择图片 */}
                  <AiFillCheckCircle
                    size={30}
                    className=" text-orange-500/80"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      updateSelectList((draft) => {
                        // 包含就移除,不包含就添加
                        if (draft.includes(item.imageName)) {
                          draft.splice(draft.indexOf(item.imageName), 1);
                        } else {
                          draft.push(item.imageName);
                        }
                        return draft;
                      });
                    }}
                  />
                  {/* 查看详情 */}
                  <AiFillInfoCircle
                    size={30}
                    className=" text-orange-500/80"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setViewerImage({
                        ...item,
                        imageUrlOnline: !useNAT
                          ? item.imageUrlOnline
                          : item.imageUrlOnline?.replace('http://192.168.31.60:8080', bizBaseUrlLocal),
                      });
                    }}
                  />
                  {/* 查看更多 */}
                  <AiFillPlusCircle
                    size={30}
                    className=" text-orange-500/80"
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const imageList: OpsImageDT[] = (await SickzilApi.opsPostImage(item.postUuid)).result;
                      imageList.forEach((item) => {
                        item.imageUrlOnline = !useNAT
                          ? item.imageUrlOnline
                          : item.imageUrlOnline?.replace('http://192.168.31.60:8080', bizBaseUrlLocal);
                      });
                      Modal.show({
                        title: null,
                        closeOnAction: true,
                        closeOnMaskClick: true,
                        content: (
                          <>
                            <div>
                              <div>图片总数：{imageList.length}</div>
                              <Grid
                                columns={3}
                                className=" text-[10px]/3"
                              >
                                <div>预先舍弃：{imageList.filter((item) => item.preTrash == 1).length}</div>
                                <div>涩涩舍弃：{imageList.filter((item) => item.isNsfw == 1).length}</div>
                                <div>单色舍弃：{imageList.filter((item) => item.preTrashSolid == 1).length}</div>
                                <div>执行舍弃：{imageList.filter((item) => item.actionType == 1).length}</div>
                                <div>执行保留：{imageList.filter((item) => item.actionType == 2).length}</div>
                                <div>执行等待：{imageList.filter((item) => item.actionType == 0).length}</div>
                              </Grid>
                            </div>
                            {imageList
                              ?.filter((image) => image.actionType != 2)
                              ?.map((image) => (
                                <div key={item.imageName + index + Math.random()}>
                                  <div className=" relative ">
                                    <img
                                      src={!useNAT ? image.imageUrl : image.imageUrlOnline}
                                      style={{ minHeight: window.innerWidth / 3 }}
                                    />
                                    {/* 保留图片 */}
                                    <AiFillCheckCircle
                                      size={30}
                                      className=" absolute bottom-2 right-2 text-orange-500/80"
                                      onClick={async (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        await SickzilApi.opsAction({
                                          actionType: 2,
                                          imageNameList: [image.imageName],
                                        });
                                        fetchProcess();
                                        Toast.show('已保留' + item.postTitle);
                                      }}
                                    />
                                  </div>
                                  <div className=" m-1 text-center">{image.imageName}</div>
                                </div>
                              ))}
                          </>
                        ),
                      });
                    }}
                  />
                  {/* 废弃帖子 */}
                  <AiFillCloseCircle
                    size={30}
                    className=" text-orange-500/80"
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const submit = window.confirm('确定移除' + item.postTitle + '?');
                      if (submit) {
                        await SickzilApi.opsTrashPost(item.postUuid);
                        fetchProcess();
                        updateSelectList((draft) => {
                          draft = draft.filter((image) => item.imageName !== image);
                          return draft;
                        });
                        Toast.show('已移除' + item.postTitle);
                      }
                    }}
                  />
                </div>
              </div>
              <Ellipsis
                content={item.imageName}
                rows={1}
                className={[
                  item.actionType == 1 && ' text-red-500',
                  item.actionType == 2 && ' text-sky-500',
                  ' m-2 text-center',
                ].join(' ')}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)' /* 将元素移动回居中 */,
                }}
                className={[
                  !selectList.includes(item.imageName) && 'hidden',
                  ' rounded-md shadow-md bg-slate-500/80 p-3',
                ].join(' ')}
              >
                {actionType == 1 && (
                  <>
                    <AiFillCloseCircle
                      size={30}
                      className={[' text-red-500/100'].join(' ')}
                    />
                  </>
                )}
                {actionType == 2 && (
                  <>
                    <AiFillCheckCircle
                      size={30}
                      className={[' text-sky-500/100'].join(' ')}
                    />
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className=" text-center p-2 mx-2 my-4">当前数量：{imageList.length}</div>
        {/* 确定执行 */}
        <div
          className={[
            selectList.length == 0 && 'hidden',
            ' fixed bottom-5 left-0 w-full flex justify-around items-center',
          ].join(' ')}
        >
          <div
            className={[
              actionType == 0 && 'from-gray-300/100 to-slate-500/100',
              actionType == 1 && 'from-pink-300/100 to-red-500/100',
              actionType == 2 && 'from-sky-300/100 to-blue-500/100',
              ' font-bold p-2 rounded-md shadow-md text-center text-white bg-gradient-to-br ',
            ].join(' ')}
            onClick={() => {
              updateSelectList((draft) => {
                draft = [];
                return draft;
              });
            }}
          >
            全部取消
          </div>
          <div
            className={[
              actionType == 0 && 'from-gray-300/100 to-slate-500/100',
              actionType == 1 && 'from-pink-300/100 to-red-500/100',
              actionType == 2 && 'from-sky-300/100 to-blue-500/100',
              ' font-bold p-2 rounded-md shadow-md text-center text-white bg-gradient-to-br ',
            ].join(' ')}
            onClick={async () => {
              if (actionType == 0) {
                Toast.show('请选择模式');
                return;
              }
              const resp = await SickzilApi.opsAction({
                actionType: actionType,
                imageNameList: selectList,
              });
              if (!resp.successful) {
                Toast.show('操作失败');
              } else {
                Toast.show('操作成功');
                // 删除图片
                updateImageList((draft) => {
                  draft = draft.filter((image) => !selectList.includes(image.imageName));
                  return draft;
                });
                // 清空选择
                updateSelectList((draft) => {
                  draft = [];
                  return draft;
                });
                // 更新进度
                fetchProcess();
              }
            }}
          >
            {`选中 ${selectList.length} 项`}
            {actionType == 1 && (
              <>
                <span> | 执行废弃</span>
              </>
            )}
            {actionType == 2 && (
              <>
                <span> | 执行保留</span>
              </>
            )}
          </div>
          <div
            className={[
              actionType == 0 && 'from-gray-300/100 to-slate-500/100',
              actionType == 1 && 'from-pink-300/100 to-red-500/100',
              actionType == 2 && 'from-sky-300/100 to-blue-500/100',
              ' font-bold p-2 rounded-md shadow-md text-center text-white bg-gradient-to-br ',
            ].join(' ')}
            onClick={() => {
              Modal.show({
                title: null,
                closeOnAction: true,
                closeOnMaskClick: true,
                content: (
                  <>
                    {selectList?.map((image) => (
                      <div key={image}>
                        <div className=" relative ">
                          <img
                            // src={!useNAT ?imageList.find(item => item.imageName == image) image.imageUrl : image.imageUrlOnline}
                            src={
                              !useNAT
                                ? imageList.find((item) => item.imageName == image).imageUrl
                                : imageList.find((item) => item.imageName == image).imageUrlOnline
                            }
                            style={{ minHeight: window.innerWidth / 3 }}
                          />
                          {/* 取消选择 */}
                          <AiFillCloseCircle
                            size={30}
                            className=" absolute bottom-2 right-2 text-orange-500/80"
                            onClick={async (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              updateSelectList((draft) => {
                                draft.splice(draft.indexOf(image), 1);
                                return draft;
                              });
                              fetchProcess();
                              Toast.show('已取消' + image);
                            }}
                          />
                        </div>
                        <div className=" m-1 text-center">{image}</div>
                      </div>
                    ))}
                  </>
                ),
              });
            }}
          >
            复核选择
          </div>
        </div>
      </div>
      {/* 底部操作 */}
      <center className="">
        <div
          className=" p-2 text-white bg-slate-500 shadow-md rounded-md m-2 "
          onClick={() => {
            pageImageAction(actionType);
            scrollTop();
          }}
        >
          刷新
        </div>
        <div
          className=" p-2 text-white bg-slate-500 shadow-md rounded-md m-2 "
          onClick={() => {
            pageImageAction(actionType, true, 9999999);
            scrollTop();
          }}
        >
          全部
        </div>
      </center>
      <div className=" fixed bottom-16 right-2 bg-slate-500 p-2 m-2 text-white shadow-md rounded-md">
        <AiOutlineArrowUp
          size={24}
          onClick={() => {
            scrollTop();
          }}
        />
      </div>
    </div>
  );
};

export default Ops;
